import { Component } from '@angular/core';
import { ButtonComponent } from '../../../generic/button/button.component';
import { environment } from '../../../../../environments/environment';
import { logout, resetUserState } from '../../../../store/user/user.actions';
import { Store } from '@ngrx/store';
import { LocalForageUtilities} from "../../../../utilities/browser/localForage.utilities";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
  imports: [ButtonComponent],
})
export class LoginComponent {
  constructor( private store: Store, private localForage: LocalForageUtilities) {}

  ngOnInit() {
    this.store.dispatch(logout());
    this.store.dispatch(resetUserState());
    this.localForage.cleanupExpired();
  }

  private clientId: string = environment.cognito.ClientId;
  private providerUrl: string = environment.cognito.ProviderUrl;
  private identityProvider: string = environment.cognito.IdentityProvider;

  connectToAuthProvider() {
    const redirectUri = environment.authCallBack;
    const cognitoUrl = this.buildCognitoUrl(redirectUri);

    window.open(cognitoUrl, '_self');
  }

  private buildCognitoUrl(redirectUri: string): string {
    return `${this.providerUrl}?response_type=token&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&identity_provider=${this.identityProvider}`
  }
}
